import { useState, useEffect } from 'react';
import { fetchProjects, fetchProjectById, fetchFeaturedProjects } from '../services/projectService';

export function useProjects(type = 'all') {
  const [projects, setProjects] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchProjects(type)
      .then(setProjects)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [type]);

  return { projects, loading, error };
}

export function useProject(id) {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    fetchProjectById(id)
      .then(setProject)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [id]);

  return { project, loading, error };
}

export function useFeaturedProjects(limit = 4) {
  const [projects, setProjects] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    fetchFeaturedProjects(limit)
      .then(setProjects)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [limit]);

  return { projects, loading, error };
}
